export default {
  barTitle: 'Sütik',
  barDescription: 'Saját, illetve harmadik féltől származó sütiket használunk annak érdekében, hogy megmutassuk ezt a weboldalt, és jobban megértsük, hogyan használja azt, azzal a céllal, hogy javítsuk az általunk kínált szolgáltatásokat. Ha folytatod a böngészést, úgy gondoljuk, hogy elfogadtad a sütiket.',
  acceptAll: 'Összes elfogadása',
  declineAll: 'Összes elutasítása',
  manageCookies: 'Sütikk kezelése',
  unsaved: 'Mentés nélküli beállítások vannak',
  close: 'Bezár',
  save: 'Mentés',
  necessary: 'Szükséges sütikk',
  optional: 'Opcionális sütik',
  functional: 'Funkcionális sütik',
  blockedIframe: 'Ennek megtekintéséhez, engedélyezd a funkcionális sütik használatát',
  here: 'itt'
}
